import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/Auth/Login";
import { useAuth } from "../services/AuthServices";
import PriviteRoute from "./PriviteRoute";
import { Box } from "@mui/material";

function IndexRouter() {
  const { loading, user } = useAuth();

  if (loading) {
    return <div>loading ....</div>;
  }
  return (
    <Box sx={{ background: "#F6F6F6" }}>
      <Routes>
        <Route path="/login" element={<Login />} />

        {PriviteRoute.map((p, index) => (
          <Route
            key={index} // Use index as a key
            path={p.path}
            element={
              user ? (
                Array.isArray(p.role) ? (
                  p.role.includes(user.Role) ? (
                    p.element
                  ) : (
                    <Navigate to="/unauthorized" replace />
                  )
                ) : user.Role === p.role ? (
                  p.element
                ) : (
                  <Navigate to="/unauthorized" replace />
                )
              ) : (
                <Navigate
                  to={`/login?redirect=${encodeURIComponent(p.path)}`}
                  replace
                />
              )
            }
          />
        ))}
      </Routes>
    </Box>
  );
}

export default IndexRouter;
